type FeedbackOption = {
  id: string;
  key: string;
  text: string;
  iconProps: { iconName: string };
};

const options: FeedbackOption[] = [
  {
    id: "Like",
    key: "What do you like?",
    iconProps: { iconName: "Emoji2" },
    text: "I like something",
  },
  {
    id: "Dislike",
    key: "How can we improve?",
    iconProps: { iconName: "EmojiNeutral" },
    text: "I don't like something",
  },
  {
    id: "Idea",
    key: "Share your ideas",
    iconProps: { iconName: "Lightbulb" },
    text: "I have an idea",
  },
];

export default options;
